import React from 'react';

export default function SchemaMarkup() {
  // 1. Organization & Local Business (Tells Google who you are)
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Prince IT Solution",
    "alternateName": "Prince IT",
    "url": "https://www.princeitsolution.com",
    "logo": "https://www.princeitsolution.com/assets/images/white-logo.png",
    "image": "https://www.princeitsolution.com/assets/images/hero-bg.jpg",
    "telephone": "+91-90237-96107",
    "email": "info@princeitsolution.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Silver Trade Center, 504, VIP Cir, beside Oxygen Park, Mota Varachha",
      "addressLocality": "Surat",
      "addressRegion": "Gujarat",
      "postalCode": "394105",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "21.2384",
      "longitude": "72.8872"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-90237-96107",
      "contactType": "customer service",
      "areaServed": "Global",
      "availableLanguage": ["en", "Hindi", "Gujarati"]
    },
    "sameAs": [
      "https://www.instagram.com/princeit_solution/",
      "https://www.linkedin.com/company/prince-it-solution/",
      "https://www.facebook.com/princeitsolution"
    ],
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "opens": "09:00",
      "closes": "19:00"
    }
  };

  // 2. WebSite Schema (For the Search Bar and Sitelinks in search results)
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Prince IT Solution",
    "alternateName": ["Prince IT", "Prince IT Solution - Best Web & Mobile App Development"],
    "url": "https://www.princeitsolution.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.princeitsolution.com/blog?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  // 3. SiteNavigationElement (Explicitly nudge Google for Sitelinks)
  const navigationSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "SiteNavigationElement",
        "position": 1,
        "name": "Services",
        "url": "https://www.princeitsolution.com/services"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 2,
        "name": "Portfolio",
        "url": "https://www.princeitsolution.com/portfolio"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 3,
        "name": "About Us",
        "url": "https://www.princeitsolution.com/about-us"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 4,
        "name": "Contact Us",
        "url": "https://www.princeitsolution.com/contact-us"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 5,
        "name": "Developer Tools",
        "url": "https://www.princeitsolution.com/tools/developer"
      },
      {
        "@type": "SiteNavigationElement",
        "position": 6,
        "name": "Blog",
        "url": "https://www.princeitsolution.com/blog"
      }
    ]
  };

  // 4. BreadcrumbList (Helps create the breadcrumb path in search results)
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Services",
        "item": "https://www.princeitsolution.com/services"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Portfolio",
        "item": "https://www.princeitsolution.com/portfolio"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "About Us",
        "item": "https://www.princeitsolution.com/about-us"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Contact Us",
        "item": "https://www.princeitsolution.com/contact-us"
      }
    ]
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(navigationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </>
  );
}
